// extracted by mini-css-extract-plugin
export default {"flexContainer":"FlexContainer_flexContainer__ZDohB","flexContainerTitle":"FlexContainer_flexContainerTitle__LqkEl","flexContainerContent":"FlexContainer_flexContainerContent__vCDXA"};